<template>
    <div>
        <div class="tips">
            <el-collapse v-if="$store.state.errors.length != 0">
                <el-collapse-item title="错误信息" name="1">
                    <el-alert v-for="e in $store.state.errors" :key="e.key" :title="e.message" type="error" :closable="false">
                    </el-alert>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="qksmDiv" v-loading="loading">
            <qksm1 :T1="exprList['T1']" v-if="isData && isQksm"></qksm1>
            <qksm2 :T2="exprList['T2']" v-if="isData && isQksm"></qksm2>
            <qksm3 :T3="exprList['T3']" v-if="isData && isQksm"></qksm3>
            <qksm4 :T4="exprList['T4']" v-if="isData && isQksm"></qksm4>
            <div id="myChart4" class="echart" v-if="isData && isQksm"></div>
            <qksm5 :T1="exprList['T1']" :T5="exprList['T5']" :T3="exprList['T3']" v-if="isData && isQksm"></qksm5>
            <qksm6 :T6="exprList['T6']" v-if="isData && isQksm"></qksm6>
            <qksm7 :T7="exprList['T7']" :F03="exprList['F03']" v-if="isData && isQksm"></qksm7>
            <qksm8 :T8="exprList['T8']" v-if="isData && isQksm"></qksm8>
            <qksm9 :T9="exprList['T9']" v-if="isData && isQksm"></qksm9>
            <qksm10 :F03="exprList['F03']" v-if="isData && isQksm"></qksm10>
            <qksm11 v-if="isData && !isQksm"></qksm11>
        </div>
    </div>
</template>
<script>
import qksm1 from "@/components/21js/qksmshandong/qksm1.vue";
import qksm2 from "@/components/21js/qksmshandong/qksm2.vue";
import qksm3 from "@/components/21js/qksmshandong/qksm3.vue";
import qksm4 from "@/components/21js/qksmshandong/qksm4.vue";
import qksm5 from "@/components/21js/qksmshandong/qksm5.vue";
import qksm6 from "@/components/21js/qksmshandong/qksm6.vue";
import qksm7 from "@/components/21js/qksmshandong/qksm7.vue";
import qksm8 from "@/components/21js/qksmshandong/qksm8.vue";
import qksm9 from "@/components/21js/qksmshandong/qksm9.vue";
import qksm10 from "@/components/21js/qksmshandong/qksm10.vue";
import qksm11 from "@/components/21js/qksmshandong/qksm11.vue";
import { getDivList, getPerformanceList } from "@/api/index.js";
import { getBdata } from "@/api/zone.js";
export default {
    name: "qksm",
    data() {
        return {
            loading: true,
            divname: "",
            qksm: {},
            exprList: {},
            tables: [],
            isData: false,
            errors: this.errors,
            errorType: false,
            typeText: '',
            isPdf: false,
            year: this.$store.state.openYear == 2021 ? 2021 : 2022,
            isQksm: true,
        };
    },
    watch: {
        $route() {
            this.$store.commit("resetOrder");
            this.isQksm = eval(this.$route.query.qksm)
            this.$nextTick(function () {
                if (!this.loading && this.isQksm) {
                    this.isChart()
                }
            });
        },
    },
    async created() {
        // if (this.$store.state.divData.queren == false) {
        //     this.$router.push({ name: "部门概况", query: { divid: this.$route.query.divid, sort: "one" }, });
        // }
        this.$store.commit("resetOrder");
        this.isQksm = eval(this.$route.query.qksm)
        await this.getDivData()
        this.$nextTick(function () {
            if (!this.loading && this.isQksm) {
                this.isChart()
            }
        });
    },
    methods: {
        async getDivData() {
            this.loading = true;
            let res = await getDivList({ id: this.$route.query.divid });
            res.attachments = await this.getAttachments()
            this.$store.commit('changeDivData', res)
            if (res.status == 0) {
                this.divname = res.divname;
                this.qksm = res.qksm;
                this.tables = res.tables;
                this.typeText = res.type == 0 ? "单位" : "部门";
                let resBdata = await getBdata();
                if (resBdata.status == 0) {
                    resBdata.bdata.forEach((e) => {
                        if (this.preview(e.expr).result) {
                            this.exprList[e.name] = this.preview(e.expr).result;
                        } else {
                            this.errorType = true
                        }
                    });
                    if (this.errorType) {
                        this.$message.error('数据异常!')
                    } else {
                        this.isData = true;
                    }
                    this.loading = false
                }

                }
            },
            async getAttachments() {
                let list = []
                let nums = 1;
                let res = {}
                do {
                    res = await getPerformanceList({
                        id: this.$route.query.divid,
                        tags: "zphzb,jxzpb,czpjjg,bmpjjg,jxpjbg",
                        pageNumber: nums,
                        pageSize: 20,
                    });
                    list = list.concat(res.files);
                    nums++
                }
                while (res.files.length == 20)
                return list
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
            isChart() {
                //for (let i = 1; i <= 6; i++) {
                //    document.getElementById("myChart" + i).style.display = 'block'
                //}
                document.getElementById("myChart1").style.display = 'block'
                this.barChart(
                    document.getElementById("myChart1"),
                    "图1：收、支决算总计变动情况图",
                    [this.num(this.exprList.T1['总计_last']), this.num(this.exprList["T1"].总计)])

                if (this.exprList["T2"].项目.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart2").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart2"),
                        "图2：本年收入决算结构图",
                        this.exprList["T2"].项目
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }

                if (this.exprList["T3"].项目.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart3").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart3"),
                        "图3：本年支出决算结构图",
                        this.exprList["T3"].项目
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                document.getElementById("myChart4").style.display = 'block'
                this.barChart(
                    document.getElementById("myChart4"),
                    "图4：财政拨款收、支决算总计变动情况图",
                    [this.num(this.exprList["T4"].总计_last), this.num(this.exprList["T4"].总计)])

                document.getElementById("myChart5").style.display = 'block'
                this.barChart(
                    document.getElementById("myChart5"),
                    "图5：一般公共预算财政拨款支出决算变动情况图",
                    [this.num(this.exprList["T5"].总计_last), this.num(this.exprList["T5"].总计)])

                document.getElementById("myChart6").style.display = 'block'
                this.charts(
                    document.getElementById("myChart6"),
                    "图6：财政拨款支出决算结构图",
                    this.exprList["T5"].leiItems
                        .map((e) => {
                            return {
                                name: e.d,
                                value: this.num(e.e).toFixed(2),
                            };
                        })
                );
            }
        },

    components: {
        qksm1,
        qksm2,
        qksm3,
        qksm4,
        qksm5,
        qksm6,
        qksm7,
        qksm8,
        qksm9,
        qksm10,
        qksm11
    },
};
</script>
<style scoped>
    .el-collapse-item >>> .el-collapse-item__header {
        background-color: #FEF0F0 !important;
        color:#F56C6C;
        padding-left: 24px;
    }

    .el-collapse-item >>> .el-collapse-item__wrap {
        background-color: #FEF0F0 !important;
    }
</style>
<style>

.el-textarea textarea {
    margin: 5px 0;
}

.qksm h4 {
    text-indent: 2em;
    font-size: 20px;
    line-height: 2.5em;
}

.qksm p {
    line-height: 2em;
    text-indent: 2em;
    font-family: FangSong;
    font-size: 20px;
}

.echart {
    width: 90%;
    height: 500px;
    border: 1px red solid;
    margin: 0 auto;
    padding: 10px;
    display: none
}

.loading,
.qksmDiv {
    height: 100%;
}
    
</style>